// extracted by mini-css-extract-plugin
export default {"container":"LocalCommitteePlaceholder_container__OmRmT","textSection":"LocalCommitteePlaceholder_textSection__U5qBg","imageSection":"LocalCommitteePlaceholder_imageSection__RQcQF"};